@switch(this.srvAppMode.mode$ | async) {
  @case (AppMode.WEB) {
    <ng-container *ngTemplateOutlet="WEB_MODE_SECURE_ICONS"></ng-container>
  }
  @case (AppMode.DEMO) {
    @if (this.srvAppMode.isDemoUrl$() | async) {
      <ng-container *ngTemplateOutlet="DEMO_MODE_SECURE_ICONS"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="WEB_MODE_SECURE_ICONS"></ng-container>
    }
  }
}

<ng-template #WEB_MODE_SECURE_ICONS>
  @if ((this.skin === 1) || (this.skin !== 1 && (loggedIn | async))) {
    <div class="secure-container-1">
      @if (secureIcon.length > 0) {
        <div class="icon-container-1">
          @for (icon of secureIcon; track $index) {
            <div class="px-0 text-center">
              <img [src]="icon.image" width="70"/>
            </div>
          }
        </div>
      }
      <p class="version-1">
        <small class="d-inline text-end font-footer-version">Version: {{ databaseVersion }}</small>
      </p>
    </div>
  }

  @if (this.skin !== 1 && !(loggedIn | async)) {
    <div class="secure-container-3">
      <div class="version-3">
        <small class="font-footer-version">Version: {{ databaseVersion }}</small>
      </div>
      @if (secureIcon.length > 0) {
        <div class="icon-container-2 my-2 me-2">
          @for (icon of secureIcon; track $index) {
            <div class="secure-icon-2">
              <img [src]="icon.image" width="50"/>
            </div>
          }
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #DEMO_MODE_SECURE_ICONS>
  <div class="secure-container-2">
    @if (secureIcon.length > 0) {
      <div class="icon-container-2 w-25">
        @for (icon of secureIcon; track $index) {
          <div class="secure-icon-2">
            <img [src]="icon.image" width="70"/>
          </div>
        }
      </div>
    }
    <div class="version-2">
      <small class="font-footer-version">Version: {{ databaseVersion }}</small>
    </div>
  </div>
</ng-template>
